import gql from 'graphql-tag';
// import { AssetImageSubtype } from 'src/modules/assets';
// import { QUERY_ASSETS } from 'src/modules/assets';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';
// import { FRAGMENT_HERO } from 'src/modules/layout/components/block/hero/queries';
// import { FRAGMENT_PRODUCT_CARD } from 'src/modules/products';
// import { FRAGMENT_PRODUCT_CARD } from 'src/modules/products';
// import { FRAGMENT_ARTICLE_CARD } from 'src/modules/articles';

//Copied to avoid error - GraphQLError [Object]: Syntax Error: Unexpected Name "undefined".
const FRAGMENT_PRODUCT_CARD = gql`
  fragment productCardFields on Product {
    id
    name_en
    name_de
    slug
    product_categories {
      id
      slug
    }
    product_subcategories @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    location_types @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    assets(where: { subtype: "picture.pdp-cutout." }, sort: "sorting:asc", limit: 1) {
      # assets(where: {subtype: "picture.preview."}) {
      subtype
      file {
        url
        alternativeText
        # width
        # height
      }
    }
    product_series {
      slug
      name_en
      name_de
      designer {
        id
        name
      }
    }
  }
`;

export const FRAGMENT_ARTICLE_DETAILS = gql`
  fragment articleDetailsFields on Article {
    id
    slug
    featured_project
    article_category {
      id
      name_de
      name_en
    }
    dynamic_content {
      ...dynamicZone
    }
    products(where: { channels_in: $outputChannel }, sort: "ranking:asc") {
      ...productCardFields
    }
    hero {
      title_en
      label_en
      subline_en
      title_de
      label_de
      subline_de
      image {
        url
        caption
      }
      button {
        text_en
        text_de
        url
        external_link
        isButton: button
        overlay
        download {
          url
        }
      }
    }
  }
  ${FRAGMENT_PRODUCT_CARD}
`;

export const QUERY_ARTICLES_DETAILS = gql`
  query ArticleDetails(
    $slug: String!
    $withFilters: Boolean! = false
    $outputChannel: String! = "de_DE"
  ) {
    articles(where: { slug: $slug }, limit: 1) {
      ...articleDetailsFields

      reference {
        products(where: { channels_in: $outputChannel }, sort: "ranking:asc") {
          name_en
          name_de
          slug
          product_categories {
            id
            slug
          }
          assets(where: { subtype: "picture.pdp-cutout." }, sort: "sorting:asc", limit: 1) {
            subtype
            file {
              url
              alternativeText
            }
          }
          product_series {
            designer {
              name
            }
          }
        }
      }
    }
  }
  ${FRAGMENT_DYNAMIC_ZONES}
  ${FRAGMENT_ARTICLE_DETAILS}
`;

export const QUERY_ARTICLES_DETAILS_RELATED = gql`
  query RelatedDetailsArticles($category: String, $articleId: ID!) {
    articles(
      where: {
        article_category: $category
        _or: [{ reference_null: true }, { featured_project: true }]
        id_ne: $articleId
      }
      limit: 3
      sort: "published_at:desc"
    ) {
      slug
      article_category {
        name_de
        name_en
      }
      hero {
        title_en
        title_de
        image {
          url
        }
      }
      reference {
        reference_category {
          id
          name_en
          name_de
        }
      }
    }
  }
`;
